import { Injectable } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';
import { log } from 'util';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import swal from 'sweetalert2';
// import { AppModalComponent } from "../components/app-modal/app-modal.component";
// import { Http } from '@angular/http';

@Injectable()
export class FrontEndService {

  isOpen = false;
  // showCaps = false;
  modalRef: NgbModalRef;
  closeResult: any;

  constructor(
    private toastyService: ToastyService,
    private toastyConfig: ToastyConfig,
    private modalService: NgbModal


  ) {
    this.toastyConfig.theme = 'bootstrap';
  }

  public addToast(title, message, type) {

    // this.toastyService.default('Hi there');
    // Or create the instance of ToastOptions
    const toastOptions: ToastOptions = {
      title: title,
      msg: message,
      showClose: true,
      timeout: 5000,
      theme: 'bootstrap',
      onAdd: (toast: ToastData) => {
        // this.logService.printLog('Toast ' + toast.id + ' has been added!');
      },
      onRemove: function (toast: ToastData) {
        // this.logService.printLog('Toast ' + toast.id + ' has been removed!');
      }
    };
    // Add see all possible types in one shot
    switch (type) {
      case 'default': this.toastyService.default(toastOptions); break;
      case 'info': this.toastyService.info(toastOptions); break;
      case 'success': this.toastyService.success(toastOptions); break;
      case 'wait': this.toastyService.wait(toastOptions); break;
      case 'error': this.toastyService.error(toastOptions); break;
      case 'warning': this.toastyService.warning(toastOptions); break;
    }
  }



  /*sweetAlert(swalTitle, swalText, swalType) {
         swal({
             title: swalTitle,
             text: swalText,
             type: swalType
         });
     }
       * Open modal
       * @param header
       * @param message
       */
  openModal(header, message) {
    // if (this.isOpen) {
    //     // this.modalRef.close();
    //     this.modalRef.componentInstance.header = header;
    //     this.modalRef.componentInstance.message = message;
    // } else {
    //     this.modalRef = this.modalService.open(AppModalComponent);
    //     this.modalRef.componentInstance.header = header;
    //     this.modalRef.componentInstance.message = message;
    //     this.isOpen = true;
    //     this.modalRef.result.then((result) => {
    //         this.closeResult = `Closed with: ${result}`;
    //         this.isOpen = false;
    //     }, (reason) => {
    //         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //         this.isOpen = false;
    //     });
    // }
  }



  public showAlert(heading, message) {
    // TODO:- Add content to show popup alert
    this.openModal(heading, message);
  }

  open() {
    if (this.isOpen) {

    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  showPassword(input: any): any {
    const picon = document.querySelector('.picon');

    if (picon.classList.contains('fa-eye-slash')) {
      input.type = input.type === 'password' ? 'text' : 'text';
      picon.classList.add('fa-eye');
      picon.classList.remove('fa-eye-slash');
    } else {
      input.type = input.type === 'password' ? 'text' : 'password';
      picon.classList.remove('fa-eye');
      picon.classList.add('fa-eye-slash');
    }
  }

  sweetAlert(swalTitle, swalText, swalType) {
    swal({
      title: swalTitle,
      text: swalText,
      type: swalType
    });
  }

  confirmAlert(swalTitle, swalText, swalType, callback) {
    swal({
      title: swalTitle,
      text: swalText,
      type: swalType,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      callback(result);
    })
  }

  removeURLParameter(url, parameter) {
    // prefer to use l.search if you have a location/link object
    const urlParts = url.split('?');
    if (urlParts.length >= 2) {

      const prefix = encodeURIComponent(parameter) + '=';
      const pars = urlParts[1].split(/[&;]/g);

      // reverse iteration as may be destructive
      for (let i = pars.length; i-- > 0;) {
        // idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      url = urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
      return url;
    } else {
      return url;
    }
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/services/front-end.service.ts